export const RELATION_PATCH_GAME_TITLE = 'Relation Patch';

export const RELATION_PATCH_CYPHER_TAGLINE = '(:Broken)-[:PATCH]->(:Fixed)';

export const RELATION_PATCH_HUD_LABEL = 'Relationships patched';

export const RELATION_PATCH_LEADERBOARD_TITLE = 'Top patchers';

export const RELATION_PATCH_LEADERBOARD_SUBTITLE = 'Most relationships patched';

export const RELATION_PATCH_GAME_OVER_TITLE = 'Patch run over';

export const RELATION_PATCH_STARTING = 'Starting run…';

export const RELATION_PATCH_UNRANKED_RUN_MESSAGE =
  'Could not start a scored run - playing unranked.';

export const RELATION_PATCH_PLAY_HAND_LABEL = 'Play with hand on camera';

export const RELATION_PATCH_PLAY_HAND_HINT =
  'Uses your webcam - move your hand up and down to steer.';

export const RELATION_PATCH_PLAY_WINDOW_LABEL = 'Play with window resizing';

export const RELATION_PATCH_PLAY_WINDOW_HINT =
  'Resize the browser horizontally (80–100% width). No camera needed.';
